import Vue from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { minLength, maxLength, required, alphaNum, alpha, numeric, email, sameAs } from '@vuelidate/validators';
import { ref } from '@vue/composition-api';
import useIsFieldValid from '@/hooks/useIsFieldValid';
import ErrorMessage from '@/components/common/ErrorMessage.vue';
import CommonLabel from '@/components/common/CommonLabel.vue';
export default Vue.extend({
    name: 'InputField',
    components: { ErrorMessage, CommonLabel },
    props: {
        value: {
            type: String,
            required: false
        },
        type: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            required: false
        },
        id: {
            type: String,
            required: true
        },
        ariaLabel: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        minLength: {
            type: Number,
            required: false
        },
        maxLength: {
            type: Number,
            required: false
        },
        mandatory: {
            type: Boolean,
            required: false
        },
        email: {
            type: Boolean,
            required: false
        },
        alphaNum: {
            type: Boolean,
            required: false
        },
        numbersOnly: {
            type: Boolean,
            required: false
        },
        textOnly: {
            type: Boolean,
            required: false
        },
        sameAsValue: {
            type: String,
            required: false
        },
        maxLengthErrMsg: {
            type: String,
            required: false
        },
        minLengthErrMsg: {
            type: String,
            required: false
        },
        mandatoryErrMsg: {
            type: String,
            required: false
        },
        emailErrMsg: {
            type: String,
            required: false
        },
        alphaNumErrMsg: {
            type: String,
            required: false
        },
        numbersOnlyErrMsg: {
            type: String,
            required: false
        },
        textOnlyErrMsg: {
            type: String,
            required: false
        },
        sameAsValueErrMsg: {
            type: String,
            required: false
        },
        requiredMark: {
            type: String,
            required: false
        },
        optionalMark: {
            type: String,
            required: false
        },
        hint: {
            type: String,
            required: false
        },
        width: {
            type: String,
            required: false,
            default: 'full'
        }
    },
    setup(props, ctx) {
        const inputValue = ref(props.value);
        const rules = {
            inputValue: {
                ...(props.mandatory && { required }),
                ...(props.minLength && { minLength: minLength(props.minLength) }),
                ...(props.maxLength && { maxLength: maxLength(props.maxLength) }),
                ...(props.textOnly && { alpha }),
                ...(props.numbersOnly && { numeric }),
                ...(props.alphaNum && { alphaNum }),
                ...(props.email && { email }),
                ...(props.sameAsValue && { sameAs: sameAs(props.sameAsValue) })
            }
        };
        const $v = useVuelidate(rules, { inputValue });
        const resetErrorIfNotMandatory = (value) => {
            if (!props.mandatory && !value) {
                $v.value.inputValue.$reset();
            }
        };
        const handleInput = (e) => {
            const target = e.target;
            const { value } = target;
            ctx.emit('update:value', value);
            resetErrorIfNotMandatory(value);
        };
        const handleBlur = (e) => {
            const target = e.target;
            const { value } = target;
            $v.value.inputValue.$touch();
            resetErrorIfNotMandatory(value);
        };
        const isFieldValid = () => useIsFieldValid($v, 'inputValue');
        return {
            inputValue,
            handleInput,
            handleBlur,
            $v,
            isFieldValid
        };
    }
});
